module.exports = __webpack_public_path__ + "images/accents/accent-sl3-cc-57f5e11daf42fbea7165e093814c749f.webp";